const DevelopmentActions = {
    // IT manifest
    START_IT_MANIFEST_LOAD: "development/start-it-manifest-load",
    IT_MANIFEST_LOADED: "development/it-manifest-loaded",
    IT_MANIFEST_ERROR: "development/it-manifest-error",
    // IT test
    SELECT_IT_TEST: "development/select-it-test",
    AD_HOC_IT_TEST: "development/ad-hoc-it-test",
    IT_TEST_SUCCESS: "development/it-test-success",
    IT_TEST_ERROR: "development/it-test-error",
    RESET_IT_TEST_STATUS: "development/reset-it-test-status",
    // mockset manifest
    START_MOCKSET_MANIFEST_LOAD: "development/start-mockset-manifest-load",
    MOCKSET_MANIFEST_LOADED: "development/mockset-manifest-loaded",
    MOCKSET_MANIFEST_ERROR: "development/mockset-manifest-error",
    // mockset
    SELECT_MOCKSET: "development/select-mockset",
};

export default DevelopmentActions;



// WEBPACK FOOTER //
// ./app/data/dev/DevelopmentActions.js